var map = {
	"./custom": 2775,
	"./custom.vue": 2775,
	"./driver.harvesterhci.io": 29410,
	"./driver.harvesterhci.io.vue": 29410,
	"./driver.longhorn.io": 59308,
	"./driver.longhorn.io.vue": 59308,
	"./kubernetes.io/aws-ebs": 93204,
	"./kubernetes.io/aws-ebs.vue": 93204,
	"./kubernetes.io/azure-disk": 10033,
	"./kubernetes.io/azure-disk.vue": 10033,
	"./kubernetes.io/azure-file": 75537,
	"./kubernetes.io/azure-file.vue": 75537,
	"./kubernetes.io/cinder": 91765,
	"./kubernetes.io/cinder.vue": 91765,
	"./kubernetes.io/gce-pd": 32477,
	"./kubernetes.io/gce-pd.vue": 32477,
	"./kubernetes.io/glusterfs": 47094,
	"./kubernetes.io/glusterfs.vue": 47094,
	"./kubernetes.io/no-provisioner": 1255,
	"./kubernetes.io/no-provisioner.vue": 1255,
	"./kubernetes.io/portworx-volume": 67128,
	"./kubernetes.io/portworx-volume.vue": 67128,
	"./kubernetes.io/quobyte": 90079,
	"./kubernetes.io/quobyte.vue": 90079,
	"./kubernetes.io/rbd": 43375,
	"./kubernetes.io/rbd.vue": 43375,
	"./kubernetes.io/scaleio": 54350,
	"./kubernetes.io/scaleio.vue": 54350,
	"./kubernetes.io/storageos": 43909,
	"./kubernetes.io/storageos.vue": 43909,
	"./kubernetes.io/vsphere-volume": 51668,
	"./kubernetes.io/vsphere-volume.vue": 51668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9932;